import styled from "styled-components";

export const ContentWrap = styled.div`
    display: flex;
    flex-direction: column;
    width: 1000px;
    //background-color: pink;
    margin: auto;
`;

export const Wrap = styled.div`

`;

export const Title = styled.div`
    font-size: 23px;
    font-weight: 600;
    margin-top: 20px;
`;

export const Writer = styled.div`
    font-size: 14px;
    margin-top: 5px;
`;

export const TitleWrap = styled.div`
    border-bottom:1.5px solid #D9D9D9;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    padding-bottom: 10px;
`;

export const Date = styled.div`
    font-size: 14px;
    margin-top: 3px;
    color: #D9D9D9;
`;

export const LikeWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
`;


export const Like = styled.img`
    height: 30px;
`;

export const LikeCount = styled.div`
    padding-left: 3px;
    color: #B4B5B6;
    font-size: 18px;
`
export const MainContent = styled.div`
    display: flex;
    border-bottom:1.5px solid #D9D9D9;

`;

export const MainImg = styled.img`
    height: 400px;
    margin-right: 20px;
`
export const InfoWrap =styled.div`
    width: 100%;

`
export const Info = styled.div`
    height: 100px;
    border:1.5px solid #D9D9D9;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-around;
`
export const Ingredients = styled.div`
    padding: 30px;
    height: 215px;
    border:1.5px solid #D9D9D9;
    margin-bottom: 20px;
`
export const IconWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Icon = styled.img `
    height: 40px;
`;

export const IconInfo = styled.div`
    font-size: 20px;
    font-weight: 600;
    margin-left: 10px;
    color: #575757;
`;

export const A = styled.div`
    font-size: 25px;
`;

export const B = styled.div`
    margin-left: 10px;
    margin-top: 8px;
    color: #B4B5B6;
`;

export const AWrap = styled.div`
    display: flex;
    margin-bottom: 5px;
`;

export const C = styled.div`
    color: #575757;
    margin-bottom: 3px;
`;

export const Recipe = styled.div`
    width: 100%;
    height: 100%;
`;

export const T = styled.div`
    margin-top: 10px;
    font-weight: 600;
    margin-bottom: 20px;
`;

export const List = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px;
    margin-bottom: 20px;
    gap: 97px;
`;
export const ListTextWrap = styled.div`
    margin-left: 30px;
    width: fit-content;
    height: fit-content;
`;

export const ListTextT = styled.div`
    font-size: 25px;
`;

export const ListTextC = styled.div`
    color: #575757;
    margin-left: 25px;
`;

export const ListImg = styled.img`
    height: 200px;
    border-radius: 10px;
    margin-left: 50px;
`;

export const Comment = styled.div`
    text-align: center;
    color: #8A8A8A;
    margin: 50px;
    font-weight: 600;
`;